// Utility function to add rankingMethod to existing competition
// This can be called from the browser console or added as a temporary button in AdminPanel

import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

export const addRankingMethodToCompetition = async (competitionId) => {
  try {
    console.log(`Checking competition: ${competitionId}`);

    // Get current competition data
    const competitionRef = doc(db, 'competitions', competitionId);
    const competitionSnap = await getDoc(competitionRef);

    if (!competitionSnap.exists()) {
      throw new Error('Competition not found!');
    }

    const currentData = competitionSnap.data();
    console.log('Current competition data:', {
      name: currentData.name,
      rankingMethod: currentData.rankingMethod || 'NOT SET'
    });

    // Update with rankingMethod if it doesn't exist
    if (!currentData.rankingMethod) {
      await updateDoc(competitionRef, {
        rankingMethod: 'byCategory'
      });
      console.log('✅ Successfully added rankingMethod: byCategory');
      return true;
    } else {
      console.log('ℹ️  Competition already has rankingMethod:', currentData.rankingMethod);
      return false;
    }
  } catch (error) {
    console.error('Error updating competition:', error);
    throw error;
  }
};

// Make it available in the browser console
if (typeof window !== 'undefined') {
  window.addRankingMethodToCompetition = addRankingMethodToCompetition;
}
